import * as React from 'react';
import { isBefore, isAfter, startOfToday } from 'date-fns';
import { useEventCallback } from '@cian/react-utils';
export function useCurrentDate(selected, min, max) {
  const [value, setValue] = React.useState(() => {
    const value = selected || startOfToday();
    return normalize(value, min, max);
  });
  const setCurrentDate = useEventCallback(nextValue => {
    setValue(normalize(nextValue, min, max));
  });
  return [value, setCurrentDate];
}
function normalize(date, min, max) {
  if (min && isBefore(date, min)) {
    return min;
  }
  if (max && isAfter(date, max)) {
    return max;
  }
  return date;
}